import type { CustomOption } from "core/catalog";
import { DateInput } from "~/design-system/components";
import { CustomOptionLabel } from "./CustomOptionLabel";

type DateInputOptionProps = {
  customOption: CustomOption;
  onChange?: (value: string) => void;
};

export function DateInputOption({
  customOption,
  onChange,
}: DateInputOptionProps) {
  const handleChange = (value: string) => {
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <DateInput
      name={customOption.id}
      label={<CustomOptionLabel customOption={customOption} />}
      placeholder={customOption.description}
      defaultValue={customOption.defaultValue as string}
      onChange={handleChange}
      classes={{
        wrapper: "w-full",
        label: "w-fit",
      }}
    />
  );
}
